import axios from '@/http'
// 检测词汇是否禁用
export function isBadWord(data) {
    return axios({
        url: '/api/bad-key-word/is-bad-word',
        method: 'GET',
        params: data
    })
}

// 检测词汇是否禁用(数组)
export function isBadWords(data) {
    return axios({
        url: '/api/bad-key-word/is-bad-words',
        method: 'POST',
        data
    })
}

// 登录
export function appletLogin(data) {
    return axios({
        url: '/api/teacher-applet/login',
        method: 'POST',
        data
    })
}


//退出
export function logoutApi() {
    return axios({
        url: '/api/user/logout',
        method: 'GET'
    })
}

// 获取access_token
export function getAccessToken(data) {
    return axios({
        url: '/api/teacher-applet/get-access-token',
        method: 'POST',
        data
    })
}

// 获取老师小程序二维码
export function getQrCode(data) {
    return axios({
        url: `/api/teacher-applet/get-qr-code`,
        method: 'post',
        data
    })
}


// 获取用户的新功能通知列表
export function getNewFunctionNotifications() {
    return axios({
        url: '/api/personal-center/get-new-function-notifications',
        method: 'GET',
    })
}

// 新功能通知置为已读
export function readNewFunctionNotifications(function_type_id) {
    return axios({
        url: '/api/personal-center/read-new-function-notification?function_type_id=' + function_type_id,
        method: 'POST',
    })
}


// 学生检测是否已绑定家长接口
export function isBindParent() {
    return axios({
        url: '/api/student-index/is-bind-parent',
        method: 'GET',
    })
}

// 学生端获取家长端小程序码
export function getMiniCode() {
    return axios({
        url: '/api/teacher-register/get-mini-code',
        method: 'GET',
    })
}

// 家长绑定学生帐号
export function addStudentById() {
    return axios({
        url: '/api/personal-center/add-student-by-id',
        method: 'GET',
    })
}


//获取机构相关配置
export function getOrganization() {
    return axios({
        url: '/api/organization/get-organization',
        method: 'GET',
    })
}

// 爱数据-获取辅助相关信息
export function getAdditionalData(data) {
    return axios({
        url: '/api/ai-akadm/get-additional-data',
        method: 'post',
        data
    })
}


//获取学校服务器host列表
export function getSchoolServerApi() {
    return axios({
        url: '/api/school-server/get-school-server-host-names',
        method: 'GET'
    })
}

//检测学校本地服务器是否可用
export function checkSchoolWorkrApi(data, school_ip) {
    return axios({
        baseURL: `//${school_ip}`,
        url: '/api/tool/check-work',
        method: 'GET',
        params: data
    })
}

//检测学校本地服务器文件是否可用
export function checkServerResourceApi(data, ip) {
    return axios({
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        timeout: 300,
        responseType: 'json',
        baseURL: `//${ip}`,
        url: '/api/file/check-file?request_cross_domain=' + window.location.origin,
        method: 'POST',
        data: data
    })
}

// 老师获取试卷
export function spokenGetExam(data) {
    return axios({
        url: '/api/spoken-teacher/get-exam',
        method: 'get',
        params: data
    })
}
//获取学生口语测评试卷
export function getSpokenExam(data) {
    return axios({
        url: '/api/spoken-student/get-spoken-exam',
        method: 'GET',
        params: data
    })
}
//添加资源/试题收藏
export function examQuestionCollect(data) {
    return axios({
        url: '/api/resource-collect/add-resource-collect',
        method: 'GET',
        params: data
    })
}

//删除资源收藏
export function deleteExamQuestionCollect(data) {
    return axios({
        url: '/api/resource-collect/del-resource-collect',
        method: 'GET',
        params: data
    })
}

//获取是否已收藏和收藏总数
export function gainResourceColletcInfo(data) {
    return axios({
        url: '/api/resource-collect/get-resource-collect',
        method: 'GET',
        params: data
    })
}

// 获取科目层级
export function getSubjectbyId(data) {
    return axios({
        url: '/api/subject/get-subjects-by-course-id',
        method: 'GET',
        params: data
    })
}


export function teacherGetQuestion(data) {
    return axios({
        url: '/api/personal-center/teacher-get-question',
        method: 'GET',
        params: data
    })
}

// 获取学科
export function getSubject(data) {
    return axios({
        url: 'api/common/get-root-subjects',
        method: 'GET',
        params: data
    })
}
// 获取年级
export function getGrad(data) {
    return axios({
        url: '/api/common/get-second-subjects',
        method: 'GET',
        params: data
    })
}
// 获取章节
export function getSection(data) {
    return axios({
        url: '/api/common/get-third-subjects',
        method: 'GET',
        params: data
    })
}

// 获取所带班级多个章的课程列表
export function getSubjectsClassesCourses(data) {
    return axios({
        url: '/api/teacher-subject/get-subjects-classes-courses',
        method: 'post',
        data
    })
}

// 获取课程
export function getCourse(data) {
    return axios({
        url: '/api/common/get-courses',
        method: 'GET',
        params: data
    })
}

// 获取爱米功能开关状态
export function getFunctionSwitchStatus(data) {
    return axios({
        url: '/api/sys-function/get-function-switch-status',
        method: 'GET',
        params: data
    })
}

// 获取office在线播放url
export function getOfficeOnlineUrl() {
    return axios({
        url: '/api/sys-function/get-office-online-url',
        method: 'GET',
    })
}

// 试卷开启/关闭解析
export function exampaperSettingApi(data) {
    return axios({
        url: '/api/exampaper/setting',
        method: 'GET',
        params: data
    })
}

// 查询试卷解析状态
export function isShowExplanationApi(data) {
    return axios({
        url: '/api/teacher-learning-analysis/is-show-explanation',
        method: 'GET',
        params: data
    })
}

//获取班级等基础信息
export function gainClassCourseInfoApi(data) {
    return axios({
        url: '/api/common/get-basic-info',
        method: 'GET',
        params: data
    })
}

// 预览资源信息
export function getResourceById(data) {
    return axios({
        url: '/api/resource/get-resource-by-id',
        method: 'GET',
        params: data
    })
}

//预览试卷信息
export function getCoursePackageExam(data) {
    return axios({
        url: '/api/teacher-course/teacher-exam',
        method: 'GET',
        params: data
    })
}

// 查看资源是否已经纠错
export function checkResourceIsHandling(data) {
    return axios({
        url: '/api/suggest/check-resource-is-handling',
        method: 'GET',
        params: data
    })
}

// 保存资源纠错
export function suggestSaveResource(data) {
    return axios({
        url: '/api/suggest/save-resource',
        method: 'GET',
        params: data
    })
}


// 上传文件-----获取七牛云token
export function getUploadToken(data) {
    return axios({
        url: 'api/upload/get-upload-token',
        method: 'GET',
        params: data
    })
}

// 文件上传到后台
export function updateCdn(data) {
    return axios({
        url: '/api/upload/update-file-cdn-url',
        method: 'POST',
        data
    })
}
// 听力题添加素材
export function addMaterial(data) {
    return axios({
        url: '/api/material/add-material',
        method: 'GET',
        params: data
    })
}


//获取班级课堂问题未回答数量
export function answerCount(data) {
    return axios({
        url: '/api/teacher-index/get-subject-question-not-answer-count',
        method: 'POST',
        data
    })
}


// 检测是否需要开通校内资源库协议
export function isNeedAgreeSchoolProtocol(data) {
    return axios({
        url: '/api/prepare-course/is-need-agree-school-protocol',
        method: 'POST',
        data
    })
}

// 获取开通校内资源库协议
export function getPepositoryProtocol() {
    return axios({
        url: '/api/protocol/get-repository-protocol',
        method: 'GET',
    })
}

// 获取开通校内资源库协议
export function setPepositoryProtocol(data) {
    return axios({
        url: '/api/protocol/set-repository-protocol-status',
        method: 'GET',
        params: data
    })
}

// 学生端提交答卷数据
export function studentSubmitExamAnswer(data) {
    return axios({
        url: '/api/exam/student-submit-exam-answer',
        method: 'POST',
        data
    })
}

// 学生端提交单提数据
export function studentSubmitExamOneAnswer(data) {
    return axios({
        url: '/api/exam/student-submit-one-question-answer',
        method: 'POST',
        data
    })
}

// 临时保存学生答题记录
export function updateAnswerExamTemp(data) {
    return axios({
        url: '/api/student-course/update-answer-exam-temp',
        method: 'POST',
        data
    })
}

// 学生端解析是否打开
export function studentAnayStatus(data) {
    return axios({
        url: '/api/exampaper/show',
        method: 'GET',
        params: data
    })
}

// 获取试卷答题临时记录
export function getAnswerExamTemp(data) {
    return axios({
        url: '/api/student-course/get-answer-exam-temp',
        method: 'GET',
        params: data
    })
}

// 错题统计-获取错误类别
export function getWrongQuestionTypes(data) {
    return axios({
        url: '/api/statistics/get-wrong-question-types',
        method: 'GET',
        params: data
    })
}

// 错题统计-添加错题归类
export function settingWrongQuestion(data) {
    return axios({
        url: '/api/wrong-question/setting-wrong-question-type',
        method: 'POST',
        data: data
    })
}

// 添加课堂问题
export function sendSubjectQuestion(data) {
    return axios({
        url: '/api/subject-question/send-subject-question',
        method: 'POST',
        data: data
    })
}

//获取本节错题分页
export function getWrongQuestions(data) {
    return axios({
        url: '/api/student-course/get-wrong-questions',
        method: 'GET',
        params: data
    })
}

//获取解析题答题记录
export function getAnalyticAnswers(data) {
    return axios({
        url: '/api/teacher-course/get-analytic-answers',
        method: 'GET',
        params: data
    })
}

//复制试卷信息
export function copyCourseExam(data) {
    return axios({
        url: '/api/teacher-course/copy-course-exam',
        method: 'POST',
        data
    })
}

// 老师复制班级课程答题卡
export function copyCourseExamCard(data) {
    return axios({
        url: '/api/exam-card-teacher/copy-course-exam-card',
        method: 'POST',
        data
    })
}

//试卷解析-检测试卷解析是否开启和补充资料是否存在
export function examAndAnalyticStatus(data) {
    return axios({
        url: '/api/exam-paper/exam-and-analytic-status',
        method: 'GET',
        params: data
    })
}

//爱数据用户数据
export function getUserData(data) {
    return axios({
        url: '/api/ai-akadm/get-user-data',
        method: 'GET',
        params: data
    })
}

//获取微信扫码登录的二维码
export function wechatConnectUrl(data) {
    return axios({
        url: '/api/wechat-login/qr-connect',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-检测是否已绑定爱米用户
export function wechatCheckBind(data) {
    return axios({
        url: '/api/wechat-login/check-bind',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-登录接口
export function wechatLogin(data) {
    return axios({
        url: '/api/wechat-login/login',
        method: 'GET',
        params: data
    })
}

//微信扫码登录-绑定爱米用户
export function wechatBind(data) {
    return axios({
        url: '/api/wechat-login/bind',
        method: 'POST',
        data
    })
}


// 预览答题卡附件
export function getMaterial(data) {
    return axios({
        url: '/api/exam-card-teacher/get-material',
        method: 'GET',
        params: data
    })
}
export function getStudentMaterial(data) {
    return axios({
        url: '/api/exam-card-student/get-material',
        method: 'GET',
        params: data
    })
}



// 设置答题卡解部分提交状态
export function setPartSubmission(data) {
    return axios({
        url: '/api/exam-card-teacher/set-part-submission',
        method: 'GET',
        params: data
    })
}


// 设置答题卡解部分提交状态
export function setAllowFill(data) {
    return axios({
        url: '/api/exam-card-teacher/set-allow-fill',
        method: 'GET',
        params: data
    })
}


// 获取答题卡设置信息
export function getExamCardSetting(data) {
    return axios({
        url: '/api/exam-card-teacher/get-exam-card-setting',
        method: 'GET',
        params: data
    })
}


// 获取答题卡数据
export function getExamCard(data) {
    return axios({
        url: '/api/exam-card-teacher/get-exam-card',
        method: 'GET',
        params: data
    })
}

//学生-获取答题卡数据
export function getExamCardStudent(data) {
    return axios({
        url: '/api/exam-card-student/get-exam-card',
        method: 'GET',
        params: data
    })
}

// 上传资源---删除新资源
export function delTeacherResource(data) {
    return axios({
        url: '/api/resource/del-teacher-resource',
        method: 'GET',
        params: data
    })
}


// 获取学科
export function getAkdmSubject(data) {
    return axios({
        url: '/api/teacher-subject/get-teacher-subjects',
        method: 'GET',
        params: data
    })
}
// 获取年级
export function getAkdmGrad(data) {
    return axios({
        url: '/api/teacher-subject/get-second-subjects',
        method: 'GET',
        params: data
    })
}
// 获取章节
export function getAkdmSection(data) {
    return axios({
        url: '/api/teacher-subject/get-third-subjects',
        method: 'GET',
        params: data
    })
}

// 获取课程
export function getAkdmCourse(data) {
    return axios({
        url: '/api/teacher-subject/get-classes-courses',
        // url:'/api/teacher-subject/get-akdm-courses',
        method: 'GET',
        params: data
    })
}

//用户协议
export function softwareServiceProtocol(data) {
    return axios({
        url: '/api/organization/get-software-service-protocol',
        method: 'GET',
        params: data
    })
}

//隐私协议
export function userPrivacyProtocol(data) {
    return axios({
        url: '/api/organization/get-user-privacy-protocol',
        method: 'GET',
        params: data
    })
}

// 上报错误日志
export function reportErrorLog(data) {
    return axios({
        url: '/api/report-error-log/report-error',
        method: 'POST',
        data: data
    })
}

//获取试卷设置信息
export function AgetExamSetting(data) {
    return axios({
        url: '/api/exam/get-exam-setting',
        method: 'GET',
        params: data
    })
}

//设置试卷允许补做状态
export function AsetAllowFill(data) {
    return axios({
        url: '/api/exam/set-allow-fill',
        method: 'GET',
        params: data
    })
}

//设置试卷部分提交状态
export function AsetPartSubmission(data) {
    return axios({
        url: '/api/exam/set-part-submission',
        method: 'GET',
        params: data
    })
}

//学生补做试卷答卷
export function redoExamAnswer(data) {
    return axios({
        url: '/api/exam/redo-exam-answer',
        method: 'POST',
        data: data
    })
}


//检测是否有登录状态
export function getLoginStatusApi(data) {
    return axios({
        url: '/api/site/get-login-status',
        method: 'GET',
        params: data
    })
}

// 获取分享列表
export function getShareList(data) {
    return axios({
        url: '/api/class-course-share/get-share-list',
        method: 'GET',
        params: data
    })
}
//教培--教师--获取系统价格
export function getPrice() {
    return axios({
        url: '/api/jp-class/get-price',
        method: 'GET'
    })
}
/**********爱米用户登录一起练题*****************/
//教培--教师--获取系统价格
export function getAuthCode() {
    return axios({
        url: '/api/auth/im/get-auth-code',
        method: 'GET'
    })
}

/*****限时训练*****/

//限时训练-设置开始作答状态
export function setAnswerStart(data) {
    return axios({
        url: '/api/exam/set-answer-start',
        method: 'GET',
        params: data

    })
}
//限时训练-设置结束作答状态
export function setAnswerEnd(data) {
    return axios({
        url: '/api/exam/set-answer-end',
        method: 'GET',
        params: data
    })
}
//获取个人信息
export function getUserInfoApi(data) {
    return axios({
        url: '/api/teacher-applet/get-user-info',
        method: 'GET',
        params: data
    })
}


// 获取付费套餐列表
export function getPayProducts() {
    return axios({
        url: '/api/teacher-applet/get-pay-products',
        method: 'POST',
    })
}

// 获取订单付款码
export function getOrderQrCode(data) {
    return axios({
        url: '/api/teacher-applet/get-order-qr-code',
        method: 'POST',
        data
    })
}


// 检测付款情况
export function checkOrderStatus(data) {
    return axios({
        url: '/api/teacher-applet/check-order-status',
        method: 'POST',
        data
    })
}

// 兑换兑换码
export function exchangeRedeemCode(data) {
    return axios({
        url: '/api/teacher-applet/exchange-redeem-code',
        method: 'POST',
        data
    })
}
//获取个人信息
export function getInformation() {
    return axios({
        url: '/api/personal-center/get-information',
        method: 'GET',
    })
}
//注册----获取学科接口
export function registerGetSubjects() {
    return axios({
        url: '/api/teacher-applet/get-subjects',
        method: 'GET',
    })
}
//注册----提交注册信息
export function registerSubmit(data) {
    return axios({
        url: '/api/channel-model/register',
        method: 'POST',
        data
    })
}

//学生提问功能是否关闭
export function stuAskQuestionCloseStatus() {
    return axios({
        url: '/api/student-course/ask-question-close-status',
        method: 'GET',
    })
}
